import axios from "./axiosInstance";
import { RAKE_REPORT } from "./apiEndPoints";

export async function downloadRakeReport(opts?: {
  rakeMasterId?: string;
  date?: string;
}): Promise<void> {
  try {
    const params = opts?.rakeMasterId
      ? { rakeMasterId: opts.rakeMasterId }
      : opts?.date
      ? { date: opts.date }
      : undefined;
    const res = await axios.get(RAKE_REPORT, {
      params,
      responseType: "blob",
    });

    const disposition = res.headers?.["content-disposition"] as
      | string
      | undefined;
    const filename =
      disposition?.match(/filename="([^"]+)"/)?.[1] ?? "rake-report.xlsx";

    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  } catch (error: any) {
    const blob: Blob | undefined = error?.response?.data;
    if (blob instanceof Blob && blob.type.includes("json")) {
      const text = await blob.text();
      try {
        const parsed = JSON.parse(text);
        throw new Error(parsed.message || "Failed to generate rake report");
      } catch (e) {
        if (e instanceof Error && e.message) throw e;
      }
    }
    throw error;
  }
}
